export class URLLoaderDataFormat {
    public static BINARY = "binary";
    public static TEXT = "text";
    public static VARIABLES = "variables";
}
